import React from 'react';
import {Route, Routes} from 'react-router-dom';
import {mediaTypeValues} from './MediaType';

const PARENT_PREFIX = '/apps/:appId/media';

// 父级 <Route path="media">（绝对路径 /apps/:appId/media）已经消耗了 /apps/:appId/media，
// 子级 <Routes> 必须用相对路径。菜单配置里保持绝对路径便于 navigate/matchPath。
const toRelative = (absPath) => {
    if (absPath === PARENT_PREFIX) {
        return '';
    }
    if (absPath === '*') {
        return '*';
    }
    if (absPath.startsWith(PARENT_PREFIX + '/')) {
        return absPath.slice(PARENT_PREFIX.length + 1);
    }
    return absPath;
};

export const MediaRouteConfig = [
    {
        path: '/apps/:appId/media',
        exact: true,
        component: require('./pages/NewsPage').default,
    },
    ...mediaTypeValues,
];

export const MenuConfig = MediaRouteConfig.filter(item => !!item.label);

export default function MediaRoutes() {
    return (
        <Routes>
            {MediaRouteConfig.map(({path, component: Component}) => {
                return (
                    <Route
                        key={`media-route${path}`}
                        path={toRelative(path)}
                        element={<Component />}
                    />
                );
            })}
        </Routes>
    );
}
